/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Activebuchungenofchildren3Inputs */



/**

* @param {_Field_Activebuchungenofchildren3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_activebuchungenofchildren3 = /** @type {((inputs?: _Field_Activebuchungenofchildren3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Activebuchungenofchildren3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Aktive Buchungen der Kinder")
});
export { _field_activebuchungenofchildren3 as "_field_activeBuchungenOfChildren" }